import { getAdminUsers } from '@selectors/adminUsers';
import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import SidebarAdminRowItem from './SidebarAdminRowItem';
import { calendarBarColors } from '@constants/calendar';

const SidebarAdminRow: React.FC<SidebarAdminRowProps> = ({
    adminIDs,
    isSubItem,
    stage,
    setTooltipContent,
}) => {
    const adminUsers = useSelector(getAdminUsers);
    const formattedAdmins = adminIDs
        .map(id => adminUsers[id])
        .filter(admin => !!admin)
        .sort((a, b) => a.firstName.localeCompare(b.firstName));

    const adminsToDisplay = formattedAdmins.slice(0, 3);

    let color = calendarBarColors.workshop;
    if (!!stage) color = calendarBarColors[stage];
    return (
        <div className="admin-row">
            {adminsToDisplay.map((admin, i) => (
                <SidebarAdminRowItem
                    admin={admin}
                    key={i}
                    adminList={formattedAdmins}
                    ellipsis={i === 2 && formattedAdmins.length > 3}
                    isSubItem={isSubItem}
                    color={isSubItem ? color : undefined}
                    setTooltipContent={setTooltipContent}
                />
            ))}
        </div>
    );
};

interface SidebarAdminRowProps {
    adminIDs: Array<number>;
    isSubItem?: boolean;
    stage?: string;
    setTooltipContent: Dispatch<SetStateAction<string[]>>;
}

export default SidebarAdminRow;
